// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design Tokens - Technical Indicator Color Palette */
.vnsc-root {
  --vnsc-indicator-1: #2962ff;
  --vnsc-indicator-2: #ff6d00;
  --vnsc-indicator-3: #e040fb;
  --vnsc-indicator-4: #00bcd4;
  --vnsc-indicator-5: #ffeb3b;
  --vnsc-indicator-6: #4caf50;
  --vnsc-indicator-7: #ff5252;
  --vnsc-indicator-8: #7c4dff;
  --vnsc-indicator-9: #00e676;
  --vnsc-indicator-10: #ff9100;

  --vnsc-macd-signal: #ff6d00;
  --vnsc-macd-histogram-positive: var(--vnsc-color-bullish);
  --vnsc-macd-histogram-negative: var(--vnsc-color-bearish);

  --vnsc-bb-upper: #2962ff;
  --vnsc-bb-lower: #2962ff;
  --vnsc-bb-fill: rgba(41, 98, 255, 0.06);
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/tokens/indicators.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;;EAE5B,2BAA2B;EAC3B,yDAAyD;EACzD,yDAAyD;;EAEzD,wBAAwB;EACxB,wBAAwB;EACxB,uCAAuC;AACzC","sourcesContent":["/* Design Tokens - Technical Indicator Color Palette */\r\n.vnsc-root {\r\n  --vnsc-indicator-1: #2962ff;\r\n  --vnsc-indicator-2: #ff6d00;\r\n  --vnsc-indicator-3: #e040fb;\r\n  --vnsc-indicator-4: #00bcd4;\r\n  --vnsc-indicator-5: #ffeb3b;\r\n  --vnsc-indicator-6: #4caf50;\r\n  --vnsc-indicator-7: #ff5252;\r\n  --vnsc-indicator-8: #7c4dff;\r\n  --vnsc-indicator-9: #00e676;\r\n  --vnsc-indicator-10: #ff9100;\r\n\r\n  --vnsc-macd-signal: #ff6d00;\r\n  --vnsc-macd-histogram-positive: var(--vnsc-color-bullish);\r\n  --vnsc-macd-histogram-negative: var(--vnsc-color-bearish);\r\n\r\n  --vnsc-bb-upper: #2962ff;\r\n  --vnsc-bb-lower: #2962ff;\r\n  --vnsc-bb-fill: rgba(41, 98, 255, 0.06);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
